import getHelper from '../../../services/getHelper';

export default getHelper('/certification-holders/:id');
